(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var scope = document.querySelector('.product__section-details__inner--upsell_combo .upsell-combo');
    if (!scope) return;

    var card       = scope.querySelector('.uc-card');
    var sizeSelect = scope.querySelector('.uc-size');
    var addBtn     = scope.querySelector('[data-add-combo]');
    if (!card || !addBtn) return;

    function currentUpsellId() {
      var chosen = sizeSelect && sizeSelect.value ? sizeSelect.value : null;
      return chosen || card.getAttribute('data-upsell-default-id');
    }

    addBtn.addEventListener('click', function () {
      // Prefer the variant ID inside this section’s product form (keeps in sync with swatches)
      var sectionId = scope.getAttribute('data-section-id');
      var scopedVar = document.querySelector('#shopify-section-' + sectionId + ' form[action^="/cart/add"] input[name="id"]');
      var baseId    = (scopedVar && scopedVar.value) ? scopedVar.value : card.getAttribute('data-base-id');
      var upsellId  = currentUpsellId();

      if (!baseId || !upsellId) { window.location.href = '/cart'; return; }

      var payload = { items: [ { id: baseId, quantity: 1 }, { id: upsellId, quantity: 1 } ] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function ()     { window.location.href = '/cart'; })
      .catch(function ()    { window.location.href = '/cart'; });
    });
  });
})();
